package one.healthium.profile.ui.update_food

sealed interface UpdateFoodEvents {
    data object OnFoodSaved : UpdateFoodEvents
}